import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { AUTH_TOKEN } from "constants/AuthConstant";
import FirebaseService from "services/FirebaseService";
import AuthService from "services/AuthService";
const BASE_URL = process.env.REACT_APP_API_URL;
const API_URL = `${BASE_URL}/authorizations`;
const { createSlice } = require("@reduxjs/toolkit");
const initialState = {
  authorizations: [], 
  currentAuthorization: null, 
    loading: false,
    error: null,
};
// Création d'une instance Axios avec un interceptor
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
      "Content-Type": "application/json",
  },
});


// Interceptor pour ajouter le token
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem(AUTH_TOKEN);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


export const createAuthorization = createAsyncThunk(
  "authorizations/create",
  async (authorization, { rejectWithValue }) => {
      try {
          const response = await axiosInstance.post("/", { authorization });
          if (!response?.data) {
              throw new Error("Réponse API invalide");
          }
          return response.data;
      } catch (error) {
          return rejectWithValue(error.response?.data || error.message);
      }
  }
);

export const fetchAuthorizations = createAsyncThunk(
  "authorizations/fetchAll",
  async (_, { rejectWithValue }) => {
      try {
          const response = await axiosInstance.get("/");
          return response.data?.data || []; // Adapté à votre structure de réponse
      } catch (error) {
          return rejectWithValue(error.response?.data || error.message);
      }
  }
);
const authorizationSlice = createSlice({
  name: "authorization",
  initialState,
  reducers: {
    setAuthorizationsState: (state, { payload }) => {
      state.authorization = payload;
  },
      setAuthorizations: (state, { payload }) => {
          state.authorizations = payload;
      },
      addNewAuthorization: (state, { payload }) => {
          state.authorizations.push(payload);
      },
      clearCurrentAuthorization: (state) => {
          state.currentAuthorization = null;
      },
  },
  extraReducers: (builder) => {
      builder
          .addCase(createAuthorization.pending, (state) => {
              state.loading = true;
              state.error = null;
          })
          .addCase(createAuthorization.fulfilled, (state, { payload }) => {
              state.loading = false;
              state.authorizations.push(payload);
          })
          .addCase(createAuthorization.rejected, (state, { payload }) => {
              state.loading = false;
              state.error = payload;
          })
          .addCase(fetchAuthorizations.pending, (state) => {
              state.loading = true;
              state.error = null;
          })
          .addCase(fetchAuthorizations.fulfilled, (state, { payload }) => {
              state.loading = false;
              state.authorizations = payload;
          })
          .addCase(fetchAuthorizations.rejected, (state, { payload }) => {
              state.loading = false;
              state.error = payload;
          });
  }
});

export const { 
  setAuthorizationsState,
  setAuthorizations, 
  addNewAuthorization,
  clearCurrentAuthorization 
} = authorizationSlice.actions;

export default authorizationSlice.reducer;